export default __webpack_public_path__ + "static/media/Cat.b732c8dd.png";